import { render } from "./CareersPage.vue?vue&type=template&id=00964b60&scoped=true"
import script from "./CareersPage.vue?vue&type=script&lang=js"
export * from "./CareersPage.vue?vue&type=script&lang=js"

import "./CareersPage.vue?vue&type=style&index=0&id=00964b60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00964b60"]])

export default __exports__